import React from 'react';
import { Fade } from '@material-ui/core';
import defaultLocales from 'globals/locales/default';
import { getTransactionTypeOptions } from 'globals/utils';
import FsOutlinedSearch from 'ui-elements/form-elements/FsOutlinedSearch';
import FsOutlinedSelect from 'ui-elements/form-elements/FsOutlinedSelect';
import { Caption, FiltersBox, SectionBox } from './Filters.style-elements';

interface FiltersProps {
  showSearch: boolean;
  searchPhrase: string;
  onSearchPhraseChange: (phrase: string) => void;
  type: string;
  onTypeChange: (type: string) => void;
}

const Filters: React.FC<FiltersProps> = ({
  showSearch,
  searchPhrase,
  type,
  onSearchPhraseChange,
  onTypeChange,
}) => {
  return (
    <FiltersBox>
      {showSearch && (
        <Fade in timeout={300}>
          <SectionBox>
            <FsOutlinedSearch
              value={searchPhrase}
              name="search"
              label={defaultLocales.search}
              onChange={(e) => onSearchPhraseChange(e.target.value)}
            />
          </SectionBox>
        </Fade>
      )}
      <SectionBox isLast>
        <Caption>{defaultLocales.transactionType}:</Caption>
        <FsOutlinedSelect
          options={getTransactionTypeOptions()}
          value={type}
          name="transaction-type"
          label={defaultLocales.type}
          onChange={(e) => onTypeChange(e.target.value)}
        />
      </SectionBox>
    </FiltersBox>
  );
};

export default Filters;
